/* globals CSS_CONFIG */

export const getLoginLink = (currentLocation: string): string => {
  const { COUNTRY, LANGUAGE, LOGINLINK } = CSS_CONFIG;
  const setLocale = (): string => `${COUNTRY}/${LANGUAGE}`;

  return `${LOGINLINK.replace('LOCALE', setLocale)}?from=${currentLocation}`;
};
